import { useEffect, useState } from "react";
import api from "@/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

// Shared location dropdown backed by the /masters/locations master list.
// Falls back to showing the current value (even if missing from the master)
// so legacy data still renders while the user is fixing it up.
export function LocationSelect({ value, onChange, placeholder = "Select location", testId, className, allowNone = true, disabled = false }) {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/masters/locations");
        setOptions(r.data || []);
      } catch {
        setOptions([]);
      }
    })();
  }, []);

  const names = options.map((o) => o.name);
  const hasCurrent = value && names.includes(value);
  const legacy = value && !hasCurrent ? value : null;

  return (
    <Select value={value || ""} onValueChange={(v) => onChange(v === "__none__" ? "" : v)} disabled={disabled}>
      <SelectTrigger data-testid={testId} className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {allowNone && <SelectItem value="__none__">— None —</SelectItem>}
        {options.map((o) => (
          <SelectItem key={o.id} value={o.name}>{o.name}</SelectItem>
        ))}
        {legacy && (
          <SelectItem value={legacy} disabled>
            {legacy} (legacy — add to master)
          </SelectItem>
        )}
      </SelectContent>
    </Select>
  );
}
